import { cva, type VariantProps } from 'class-variance-authority'

export { default as Alert } from './Alert.vue'
export { default as AlertDescription } from './AlertDescription.vue'
export { default as AlertTitle } from './AlertTitle.vue'

export const alertVariants = cva(
  'relative w-full rounded-lg p-4 [&>svg~*]:pl-7 [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-[15px] [&>svg]:size-5 min-h-[52px]',
  {
    variants: {
      variant: {
        default: 'bg-white',
        green: 'bg-green-500 text-white',
        blue: 'bg-blue-600 text-white',
        red: 'bg-red-500 text-white',
        yellow: 'bg-yellow-500 text-white'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
)

export type AlertVariants = VariantProps<typeof alertVariants>
